import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    id: String,
    email: String,
    redirectTo: String
  };

  declineClicked () {
    dispatchEvent(
      new CustomEvent('openModal', {
        detail: {
          actionPath: `/community/invitations/${this.idValue}`,
          title: I18n.t('community.invitations.index.decline_invite'),
          text: I18n.t(
            'community.invitations.index.decline_confirmation_text'
          ),
          email: this.emailValue,
          redirectTo: this.redirectToValue
        }
      })
    )
  }
}
